import type { UploadStatus } from "./page";

/** Safe to delete anytime except mid-flight: the upload queue holds its own
 * snapshot of a claimed page and writes back to its id/blob after the
 * network call resolves, so deleting the row and blob out from under an
 * in-flight upload either resurrects the row via a stale write or (if the
 * blob disappears before it's read) silently drops the page with no retry.
 *
 * Retake is a remove plus a re-capture at the same index, so it lives under
 * this same rule — including for `uploaded` pages, which is the whole point
 * of a reviewer's "retake page 2, it's blurry" flag. The server copy is
 * replaced when the retaken page uploads (see `replaceRemote` on Page). */
export function isRemovable(status: UploadStatus): boolean {
  return status !== "uploading";
}

export function removeRefuseReason(status: UploadStatus): string | null {
  return isRemovable(status) ? null : "Still uploading";
}

export function lastPage<T extends { pageIndex: number }>(pages: T[]): T | undefined {
  if (pages.length === 0) return undefined;
  return pages.reduce((a, b) => (a.pageIndex > b.pageIndex ? a : b));
}
